import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewEncapsulation
} from '@angular/core';
import {Router} from "@angular/router";
@Component({
    selector: 'app-input-quantity',
    templateUrl: './input-quantity.component.html',
    styleUrls: ['./input-quantity.component.scss'],
    standalone: false
})
export class InputQuantityComponent implements OnInit {

  @Output() change: EventEmitter<number> = new EventEmitter<number>();
  @Input()  maxQuantity: number=0;
  @Input() counter = 1;
  quantity?: number;
  invalidQuantity = false;
  constructor(private router : Router){

  }

  ngOnInit() {
    if (this.maxQuantity<0)
    {this.maxQuantity=0;}

    if (this.counter >= this.maxQuantity) {
      this.invalidQuantity = true;
    }
  }

  increment() {
    this.counter++;
    if (this.counter >= this.maxQuantity) {
      this.invalidQuantity = true;
    }
    this.change.emit(this.counter);
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes &&(this.router.url!='/cart')) {
      //this.counter = 1;
      this.maxQuantity = this.maxQuantity;
      this.invalidQuantity = false;
      //this.change.emit(1);
    }
  }
  decrement() {
    if (this.counter > 1)
        this.counter--;
    if (this.counter < this.maxQuantity) {
      this.invalidQuantity = false;
    }
    this.change.emit(this.counter);
  }

  onUpdate(value: number) {
    this.quantity = value;
    if (this.quantity < 1 || this.quantity > this.maxQuantity) {
      this.invalidQuantity = true;
      //this.counter = this.maxQuantity;
      this.change.emit(this.counter);
    } else {
      this.change.emit(value);
    }
  }


  isQuantity(value: number){
    this.quantity = value;

    if (this.quantity < 1 || this.quantity > this.maxQuantity) {
      this.invalidQuantity = true;
     // this.counter = this.maxQuantity;
    }else {
      this.invalidQuantity = false;
    }

  }




}
